import(/* webpackMode: "eager" */ "/vercel/path0/apps/frontend/src/app/dashboard/layout.tsx")